import { useCurrentUserType } from '../../../hooks/useCurrentUserType';
import { UserType } from '../../../consts/userType';

export const useHasAccessToProjectUpload = () => {
  const userType = useCurrentUserType();

  return [UserType.Moderator, UserType.SelfServicedPilot].includes(userType as UserType);
};
